import React from 'react'
import { COLORS } from 'utils/styles'

export const NotificationsIcon = ({ red }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    fill="none"
    viewBox="0 0 10 11"
  >
    <path
      fill={red ? COLORS.red : '#060606'}
      d="M9.236 6.622l-.623-1.036a2.181 2.181 0 01-.26-.927V3.63A3.63 3.63 0 004.732 0a3.635 3.635 0 00-3.628 3.628v1.026c0 .264-.122.7-.254.926L.226 6.617c-.237.402-.292.86-.143 1.257.148.403.485.722.926.866.595.198 1.196.342 1.809.446.06.011.12.017.181.028l.243.033a11.133 11.133 0 002.525.05c.127-.011.254-.022.375-.039a5.5 5.5 0 00.298-.039 11.613 11.613 0 002.007-.48c.425-.143.75-.462.905-.87.154-.414.11-.866-.116-1.247zM5.133 4.384a.419.419 0 11-.838 0v-1.71a.419.419 0 11.838 0v1.71zM6.28 9.903A1.662 1.662 0 014.718 11c-.436 0-.866-.177-1.169-.49a1.522 1.522 0 01-.386-.613c.072.011.143.017.22.028.127.016.26.033.392.044.314.027.634.044.954.044.314 0 .629-.017.937-.044.116-.011.232-.017.342-.033l.27-.033z"
    />
  </svg>
)
